"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recyclingSupplyTrackerChemical = void 0;
const recyclingSupplyTrackerChemical = exports.recyclingSupplyTrackerChemical = {
  RECYCLING_SUPPLY_TRACKER_CHEMICAL: {
    en: {
      title: 'Recycling Supply Tracker (Chemical)',
      subtitle: 'Connect with suppliers in complex chemical recycling markets',
      description: 'Optimise sourcing with our global database covering over 130 chemical recycling plants and projects.',
      list: ['Full visibility of key recycled plastics including R-PET, R-PP, R-HDPE and R-LDPE', 'Search by location, operational status, output volume, feedstock or process', 'Weblinks to suppliers', 'Up-to-date current and announced capacity listed by year']
    },
    zh: {
      title: '回收供应追踪（化学回收）',
      subtitle: '在复杂的化学回收市场中与供应商建立联系',
      description: '全球数据库涵盖130多套化学回收装置和项目，优化采购策略。',
      list: ['全面了解包括R-PET、R-PP、R-HDPE和R-LDPE在内的主要再生塑料', '按装置所在地、运行状态、产量、原料或工艺进行查找', '提供供应商官网链接', '按年度划分的现有和已宣布产能最新情况']
    }
  }
};